module.exports = __webpack_public_path__ + "img/full-slide-8.09bc5c40.jpg";